(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('grcPlanInitiativeFullViewController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessPlanningService', 'notificationService', 'historyCtxtService', 'grcPlanInitiativeEditModalService'];

    function Controller($scope, $state, businessPlanningService, notificationService, historyCtxtService, grcPlanInitiativeEditModalService) {

        $scope.ctrlCtxt = {
            canEdit: false,
            sections: {
                name:           {isHighlighted: false, isHelping: false},
                rationale:      {isHighlighted: false, isHelping: false},
                risksMitigated: {isHighlighted: false, isHelping: false},
                keyBenefits:    {isHighlighted: false, isHelping: false},
                resources:      {isHighlighted: false, isHelping: false},
                budget:         {isHighlighted: false, isHelping: false},
            }
        };
        $scope.grcPlanInitiativeEditModalService = grcPlanInitiativeEditModalService;
        init();

        function init() {
            initChangeTypes();

            // Can edit if Business Planning or Owners when IsEditableByOwners
            $scope.ctrlCtxt.canEdit = $scope.boxModel.HasPlanInitiative_PlanningOnlyEdit
                || ($scope.boxModel.HasPlanInitiative_Edit && $scope.boxModel.IsEditableByOwners);

            initHelpers();
        }

        function initChangeTypes() {
            if ($scope.boxModel.ChangeTypeList) {
                $scope.ctrlCtxt.changeTypeList = _.join(_.map($scope.boxModel.ChangeTypeList, 'TitleEN'), ', ');
            }
        }

        function initHelpers() {
            if ($scope.boxModel.HasPlanInitiative_PlanningOnlyEdit) return;
            if (!$scope.ctrlCtxt.canEdit) return;

            var highlightFound = false;
            var isHighlightOnRisks = false;
            var isHighlightOnKeyBenefits = false;

            // Name
            if (!$scope.boxModel.EndingFiscalYear
                && !$scope.boxModel.TargetDate
                && !$scope.boxModel.OperationalizationDate) {

                $scope.ctrlCtxt.sections.name.isHelping = true;
                $scope.ctrlCtxt.sections.name.isHighlighted = true;
                highlightFound = true;
            }

            // Rationale
            if (!$scope.boxModel.PlanCorporateObjective
                && !$scope.boxModel.ChangeTypeList.length
                && !$scope.boxModel.Objectives
                && !$scope.boxModel.DriversToChange
                && !$scope.boxModel.Scope
                && !$scope.boxModel.BusinessUnitImpactedList.length
                && !$scope.boxModel.OtherStakeholderImpactedList.length) {

                $scope.ctrlCtxt.sections.rationale.isHelping = true;

                if (!highlightFound) {
                    highlightFound = true;
                    $scope.ctrlCtxt.sections.rationale.isHighlighted = true;
                }
            }

            // Key Risks Mitigated
            if (!$scope.boxModel.KeyRisksMitigated.length) {

                $scope.ctrlCtxt.sections.risksMitigated.isHelping = true;

                if (!highlightFound) {
                    highlightFound = true;
                    isHighlightOnRisks = true;
                    $scope.ctrlCtxt.sections.risksMitigated.isHighlighted = true;
                }
            }

            // Key Benefits
            if (!$scope.boxModel.PlanCorporateMetrics.length) {

                $scope.ctrlCtxt.sections.keyBenefits.isHelping = true;

                if (!highlightFound) {
                    highlightFound = true;
                    isHighlightOnKeyBenefits = true;
                    $scope.ctrlCtxt.sections.keyBenefits.isHighlighted = true;
                }
            } else if (isHighlightOnRisks) {
                // Remove highlight on Risks if there are Key Benefits data
                $scope.ctrlCtxt.sections.risksMitigated.isHelping = false;
                $scope.ctrlCtxt.sections.risksMitigated.isHighlighted = false;
                highlightFound = false;
            }

            // Resources
            if (!$scope.boxModel.PlanBusinessUnitOwnerList.length
                && !$scope.boxModel.PlanBusinessUnitInvolvedList.length
                && !$scope.boxModel.KeyContributors.length
                && !$scope.boxModel.RequiredSMEList.length) {

                $scope.ctrlCtxt.sections.resources.isHelping = true;

                if (!highlightFound) {
                    highlightFound = true;
                    $scope.ctrlCtxt.sections.resources.isHighlighted = true;
                }
            } else if (isHighlightOnRisks || isHighlightOnKeyBenefits) {
                // Remove highlight on Risks and Key Benefits if there are Resources data
                $scope.ctrlCtxt.sections.risksMitigated.isHelping = false;
                $scope.ctrlCtxt.sections.risksMitigated.isHighlighted = false;
                $scope.ctrlCtxt.sections.keyBenefits.isHelping = false;
                $scope.ctrlCtxt.sections.keyBenefits.isHighlighted = false;
                highlightFound = false;
            }

            // Budget
            if (!$scope.boxModel.EstimatedITCostForFY
                && !$scope.boxModel.EstimatedBusinessCostForFY
                && !$scope.boxModel.EstimatedBudgetBeyondFY) {

                $scope.ctrlCtxt.sections.budget.isHelping = true;

                if (!highlightFound) {
                    highlightFound = true;
                    $scope.ctrlCtxt.sections.budget.isHighlighted = true;
                }
            }
        }

        // Return list of values concatenated
        $scope.showConcatList = function (data, path) {
            var value = _.join(_.map(data, path), ', ');
            return value === '' ? 'n/a' : value;
        };

        // Return list of Stakeholders Impacted
        $scope.showStakeholderImpactedList = function () {
            var list;
            var joined;

            list = _.map($scope.boxModel.OtherStakeholderImpactedList, 'TitleEN');
            list = _.concat(list, _.map($scope.boxModel.BusinessUnitImpactedList, 'TitleEN'));

            joined = _.join(list, ', ');

            return joined === '' ? 'n/a' : joined;
        };

        // Is Stakeholder Impacted List Empty
        $scope.isStakeholderImpactedListEmpty = function () {
            return $scope.boxModel.BusinessUnitImpactedList.length === 0
                && $scope.boxModel.OtherStakeholderImpactedList.length === 0;
        };

        // Show Submit PSS button
        $scope.showSubmitPSSButton = function () {
            if (!$scope.boxModel.HasPlanInitiative_SubmitPSSDefinition) return false;

            return $scope.boxModel.HasPlanInitiative_PlanningOnlyEdit
                    || $scope.boxModel.IsEditableByOwners;
        };

        // Edit Section
        $scope.editSection = function (sectionName, index) {
            if ($scope.ctrlCtxt.isLoading) return;

            grcPlanInitiativeEditModalService.showEditor(sectionName, $scope.boxModel, {
                onModalClose: function () {
                    if (sectionName === 'mitigated-risks') {
                        $scope.ctrlCtxt.sections.risksMitigated.isHelping = false;

                        // If highlight was on Risks, highlight the next section
                        if ($scope.ctrlCtxt.sections.risksMitigated.isHighlighted) {
                            $scope.ctrlCtxt.sections.risksMitigated.isHighlighted = false;
                            $scope.ctrlCtxt.sections.keyBenefits.isHighlighted = true;
                        }
                    } else if (sectionName === 'key-benefits') {
                        $scope.ctrlCtxt.sections.keyBenefits.isHelping = false;

                        // If highlight was on Benefits, highlight the next section
                        if ($scope.ctrlCtxt.sections.keyBenefits.isHighlighted) {
                            $scope.ctrlCtxt.sections.keyBenefits.isHighlighted = false;
                            $scope.ctrlCtxt.sections.resources.isHighlighted = true;
                        }
                    }
                }
            }, index);

        };

        // Edit Target Date section
        $scope.editTargetDate = function () {
            $scope.editSection('name', $scope.boxModel.HasPlanInitiative_PlanningOnlyEdit ? 2 : 1);
        };

        // Get number of people
        $scope.getNbAsArray = function (nbUsers) {
            if (_.isNil(nbUsers)) return [];

            // Max 10 users to display
            if (nbUsers > 10) {
                nbUsers = 10;
            }

            return new Array(_.round(nbUsers));
        };

        // Lock/Unlock Initiative
        $scope.toggleLockInitiative = function () {
            if ($scope.ctrlCtxt.isLoading) return;

            $scope.ctrlCtxt.isLoading = true;
            var actionPromise = $scope.boxModel.CreationStatusValue === 'Unlocked' ?
                businessPlanningService.lockInitiative : businessPlanningService.unlockInitiative;

            actionPromise.call(this, $scope.boxModel.PlanInitiativeID)
                .then(function (lockedInitiative) {
                    notificationService.notify('Initiative has been '
                        + (lockedInitiative.CreationStatusValue === 'Unlocked' ? 'unlocked' : 'locked')
                        + ' successfully');

                    $state.reload();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // Delete Initiative
        $scope.deleteInitiative = function () {
            if ($scope.ctrlCtxt.isLoading) return;

            $scope.ctrlCtxt.isLoading = true;

            return businessPlanningService
                     .deletePlanInitiative($scope.boxModel.PlanInitiativeID)
                     .then(function () {
                         $scope.pageIsNotDirty();

                         notificationService.notify('Plan Initiative has been deleted');

                         if (historyCtxtService.hasContext()) {
                             historyCtxtService.goToContext();
                         } else {
                             $scope.boxContext.onDeleted();
                         }
                     })
                     .finally(function () {
                         $scope.ctrlCtxt.isLoading = false;
                     });
        };

        // Show Deleted Initiatives
        $scope.showDeleteInitiative = function () {
            return !_.isUndefined($scope.boxModel.PlanInitiativeID) && !$scope.readOnly;
        };

        // Submit PSS
        $scope.submitPSS = function () {
            if ($scope.ctrlCtxt.isLoading) return;

            $scope.ctrlCtxt.isLoading = true;

            businessPlanningService
                .submitPSSDefinition($scope.boxModel.PlanInitiativeID)
                .then(function () {
                    $scope.pageIsNotDirty();

                    notificationService.notify('Plan Initiative Submitted Successfully');

                    $state.go('home',{ UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };
    }
})();